module.exports = __webpack_public_path__ + "resources/img/main_banner_gov04.84f1e03c095796c15389ff7a663462a0.png";